/**
 * Layout component that queries for data
 * with Gatsby's useStaticQuery component
 *
 * See: https://www.gatsbyjs.org/docs/use-static-query/
 */

import React, { Component } from "react"
import PropTypes from "prop-types"
import Navbar from "./menu/navbar"
import "./layout.css"
import { FaTwitter, FaInstagram, FaFacebook } from "react-icons/fa";
import { IconContext } from "react-icons";
import { Link } from "gatsby"
import ReactTooltip from 'react-tooltip'


class Layout extends Component {

  constructor(props) {
    super(props);
    this.state = { navbarOpen: false };
  }

  handleNavbar = () => {
    this.setState({ navbarOpen: !this.state.navbarOpen });
  }

  render() {
    const { children } = this.props;
    return (
      <div>
        <Navbar
          navbarState={this.state.navbarOpen} 
          handleNavbar={this.handleNavbar}
        />
        <main>
          {children}
        </main>
        <footer>
          <ReactTooltip id="custom-color-no-arrow" class="customTheme" textColor='#100504' backgroundColor='#d6756c' effect='solid'/>
          <div className="socialMediaContainer">
            <IconContext.Provider value={{ className: "social-icons" }}>
            <a href="https://twitter.com/alexthomascodes" target="_blank" rel="noopener noreferrer" data-for="custom-color-no-arrow" data-tip="Twitter">
              <FaTwitter />
            </a>
            <a href="https://www.instagram.com/alexandra_c_thomas/" target="_blank" rel="noopener noreferrer" data-for="custom-color-no-arrow" data-tip="Instagram">
              <FaInstagram />
            </a>
            <a href="https://www.facebook.com/alexandra.catherine.thomas" target="_blank" rel="noopener noreferrer" data-for="custom-color-no-arrow" data-tip="Facebook">
              <FaFacebook />
            </a>
            </IconContext.Provider>
          </div>
          <div className="bottomNavigationContainer">
            <Link to="/">Home</Link>
            <Link to="/about/">About</Link>
            <Link to="/tour/">Tour</Link>
            <Link to="/book/">Order the Book</Link>
            <Link to="/contact/">Contact</Link>
          </div>
          © {new Date().getFullYear()} | Me &amp; Bobby McGee
          <p className="shameLessPlug">Crafted with love by <a href="http://alexandracthomas.com/" style={{color: "#100504", textDecoration: "none" }}>Alexandra Thomas</a></p>
        </footer>
      </div>
    )
  }
}

Layout.propTypes = {
  children: PropTypes.node.isRequired,
}

export default Layout
